import React from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking';
import { EXTERNAL_LINKS, USER_TYPE } from '../../constants';
import S from '../../../../commons/components/style/HowSafeDealWorksModal';
import { useI18n } from '../../../../i18n';
import trackingKeys from '../../../../commons/constants/trackingKeys';

const { termsAndConditionsClick } = trackingKeys.events.safeDeal;

interface Props {
  trackingExtras: Record<string, any>;
  userType: USER_TYPE;
}

// ToDo: use this method in other places with the same logic
const byUserType = (userType: USER_TYPE, forBuyer: string, forSeller: string) => {
  if (userType === USER_TYPE.BUYER) {
    return forBuyer;
  }

  if (userType === USER_TYPE.SELLER) {
    return forSeller;
  }

  return '';
};

export const TermsAndConditionsLink = ({ trackingExtras, userType }: Props) => {
  const i18n = useI18n();
  const trackEvent = useTrackEvent();

  const onTermsAndConditionsClick = () =>
    trackEvent(termsAndConditionsClick, null, null, trackingExtras);

  return (
    <S.HelpCenterLink>
      <a
        onClick={() => onTermsAndConditionsClick()}
        href={EXTERNAL_LINKS.SAFE_DEAL_TERMS_V20}
        data-testid="how-sd-works-modal-terms-and-conditions"
        target="_blank"
        rel="noreferrer"
      >
        {i18n`dlv_safedeal_info_modal_terms_and_conditions`}
      </a>
    </S.HelpCenterLink>
  );
};
